var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from 'vue-property-decorator';
import { BRow, BCol, BCard, BAspect, BCardImg, BCardBody, BCardFooter, BButton } from 'bootstrap-vue';
import { addToCart } from 'ts/modules/cart';
let FrameProductExtra = class FrameProductExtra extends Vue {
    product;
    aspect = 1.75;
    get href() {
        return `/diy-framing/accessories/${this.product.category?.type?.slug}/${this.product.meta?.slug}`;
    }
    get priceString() {
        let string = `£${this.product.price}`;
        if (!this.product.min_quantity) {
            string += ` each`;
        }
        else {
            string += ` per ${this.product.min_quantity}`;
        }
        return string;
    }
    addToCart() {
        if (this.product.sku) {
            addToCart({
                sku: this.product.sku,
                qty: 1,
                attributes: this.product.min_quantity ? {
                    "Pack Size": this.product.min_quantity?.toString()
                } : {}
            }, false);
        }
    }
};
__decorate([
    Prop(Object)
], FrameProductExtra.prototype, "product", void 0);
FrameProductExtra = __decorate([
    Component({
        components: {
            BRow, BCol, BCard, BAspect, BCardImg, BCardBody, BCardFooter, BButton
        }
    })
], FrameProductExtra);
export default FrameProductExtra;
